import { useState, useEffect } from 'react';
import '../styles/Leaderboard.css';
import { soundManager } from '../utils/sounds';
import { getLeaderboard } from '../utils/supabase';

const RANK_ICONS = ['🥇', '🥈', '🥉'];

function Leaderboard({ stage, onClose }) {
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLeaderboard(stage.id).then(data => {
      setScores(data);
      setLoading(false);
    });
  }, [stage.id]);

  const formatTime = (seconds) => {
    if (seconds == null) return '—';
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return m > 0 ? `${m}:${s.toString().padStart(2, '0')}` : `${s}s`;
  };

  return (
    <div className="leaderboard-overlay" onClick={onClose}>
      <div className="leaderboard-modal" onClick={e => e.stopPropagation()}>
        <button className="leaderboard-close" onClick={() => { soundManager.playClick(); onClose(); }}>×</button>

        <div className="leaderboard-header">
          <span className="leaderboard-char">{stage.chinese}</span>
          <span className="leaderboard-title">{stage.english} — Top 10</span>
        </div>

        {loading ? (
          <div className="leaderboard-empty">Loading…</div>
        ) : scores.length === 0 ? (
          <div className="leaderboard-empty">No scores yet — be the first!</div>
        ) : (
          <ol className="leaderboard-list">
            {scores.map((row, i) => (
              <li key={i} className={`leaderboard-row${i < 3 ? ` rank-${i + 1}` : ''}`}>
                <span className="leaderboard-rank">
                  {i < 3 ? RANK_ICONS[i] : i + 1}
                </span>
                <span className="leaderboard-player">{row.user_name}</span>
                <span className="leaderboard-time">⏱ {formatTime(row.time_remaining)}</span>
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}

export default Leaderboard;
